import React from 'react';
import {
  SiteContainer,
  Flex,
  Wrapper,
  Main,
} from 'core/layout';
import { MetaList } from 'modules';
import { BreadcrumbsConnected } from 'elements';
import { RawContent } from 'elements/util';
import momentDate from 'utils/momentDate';
import Galerija from './components/Galerija';
import {
  FlexGroup,
  StyledHeading,
  StyledSmall,
  StyledContent,
} from './styled';

class RakstsJaunumi extends React.PureComponent {
  render() {
    const { data: {
      page,
      teksti,
      lang,
    }} = this.props;

    if (!page) {
      return null;
    }

    let acf = {};
    if (page.acf) {
      try {
        acf = JSON.parse(page.acf);
      } catch(error) { }
    }

    return (
      <SiteContainer>

        <BreadcrumbsConnected
          lang={this.props.lang}
          path={this.props.path}
        />

        <Wrapper>
          <FlexGroup>

            <Main>
              <StyledHeading>
                {page.title}
                <StyledSmall>
                  <span>
                    {momentDate(page.date_created, lang)}
                  </span>
                  <span>
                    {
                      page.terms && page.terms.post_tag && page.terms.post_tag.length > 0 && page.terms.post_tag.map(term => term.name)
                      .join(', ')
                    }
                  </span>
                </StyledSmall>
              </StyledHeading>

              {
                acf && !!acf.galerija_aktiva && (
                  <Galerija images={page.galerija} teksti={teksti} />
                )
              }

              <StyledContent>
                <RawContent content={page.content} />
              </StyledContent>
            </Main>

          </FlexGroup>
        </Wrapper>

      </SiteContainer>
    );
  }
}

export default RakstsJaunumi;



// WEBPACK FOOTER //
// ./src/pages/Raksts/RakstsJaunumi.jsx